import Link from 'next/link'
import { cn } from '@cerifi/ui/utils/cn'

import styles from './announcement-banner.module.css'

const AnnouncementBanner = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        'sticky w-full z-[1000] top-0 px-8 py-2 text-center text-sm bg-red-500',
        className,
        styles.announcementBanner
      )}
    >
      <p className="text-white capitalize">
        Now launching: Instructor-Led Online{' '}
        <span className="italic">Fast Pass</span>{' '}
        <span className="normal-case">6-month</span> education program.{' '}
        <Link href="/cfp-instructor-led-fastpass">
          Explore FastPass &#8594;
        </Link>
      </p>
    </div>
  )
}

export default AnnouncementBanner
